import React, { useEffect, useMemo, useState } from 'react'
import styles from './welcome.module.css'
import { Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import CarouselSlider from "./Carousel/Carousel";
import { ReactComponent as Ios } from '../../assets/images/wkit/appleStore.svg';
import { ReactComponent as Android } from '../../assets/images/wkit/googlePlay.svg';
import { ReactComponent as PolicyInfo } from '../../assets/images/wkit/policyInfo.svg';
import { ReactComponent as PolicyDown } from '../../assets/images/wkit/PolicyDown.svg';
import { ReactComponent as Services } from '../../assets/images/wkit/services.svg';
import { ReactComponent as YouTube } from '../../assets/images/wkit/youtube.svg';
import { ReactComponent as Instagram } from '../../assets/images/wkit/instagram.svg';
import { ReactComponent as WhatsApp } from '../../assets/images/wkit/whatsapp.svg';
import { ReactComponent as FaceBook } from '../../assets/images/wkit/facebook.svg';
import { ReactComponent as Linked } from '../../assets/images/wkit/linked.svg';
import { ReactComponent as Twitter } from '../../assets/images/wkit/twitter.svg';
import Screens from '../../assets/images/wkit/Screens.png';
import HeadComponent from './HeadComponent';
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import * as renewalServices from '../../services/renewal-service';
import * as globalUtils from "../../helpers/utils";

const WelcomeKit = () => {

    const location = useLocation();
    const { type } = useParams();
    const [typeState, setTypeState] = useState(type);
    const [policyNumber, setPolicyNumber] = useState(location.state ? location.state.policyNumber : "");
    const [amount, setAmount] = useState(location.state ? location.state.amount : "");
    const [billNumber, setBillNumber] = useState(location.state ? location.state.billNumber : "");
    const [billExpiryDate, setBillExpiryDate] = useState(location.state ? location.state.billExpiryDate : "");
    const [searchParams, setSearchParams] = useSearchParams();
    const creditCardSessionID = searchParams.get("cko-session-id");
    const refId = searchParams.get("refId");
    const { t, i18n } = useTranslation();
    const [showRow, setShowRow] = useState(true)
    let AppleSuccess = JSON.parse(localStorage.getItem("policyNoOld"))


    useEffect(() => {
        if (creditCardSessionID) {
            renewalServices.getPaymentById({ id: creditCardSessionID }).then((response) => {
                const data = response.data;
                setPolicyNumber(data.policyNo);
                setAmount(data.getPaymentDetailsByIdResponse.amount);
                setTypeState("credit")
            })
        }

    }, [creditCardSessionID]);
    console.log(type,'type')


    useEffect(() => {
        if (refId) {
            const data = {
                "systemId": "MOTOR",
                "applicationType": "RHSP",
                "langCode": globalUtils.getOneLetterLanguageCode(i18n.language),
                "referenceId": refId,
                "channelCode": "85"
            };
            renewalServices.verifyTamaraOrder(data).then((response) => {
                if (response.data.resultCode == "S") {
                    setPolicyNumber(response.data.policyNumber);
                    setAmount(response.data.totalAmount);
                    setTypeState("Tamara");
                }
            })
        }
    }, [refId])

    useEffect(() => {
        setTypeState(type)
        if (type === "sadad" || type === null) {
            setShowRow(false)
        }
    }, [type, showRow, typeState])


    useEffect(() => {
        if (refId || creditCardSessionID || AppleSuccess) {
            setShowRow(true)
        }
        else {
            setShowRow(false)
        }
    }, [refId, creditCardSessionID, AppleSuccess])


    return (
        <section className={styles.WelcomeKit}>
            <Row>
                <Col xs={12} md={6}>
                    <HeadComponent
                        productName={""}
                        policyNumber={policyNumber}
                        email={""}
                        type={type}
                        sadadBill={billNumber}
                        sadadAmount={amount}
                        systemId={"MOTOR"}
                        sadadExp={billExpiryDate}
                    />
                    <CarouselSlider />
                </Col>
                <Col xs={12} md={6}>
                    <div className={styles.wrapper + " " + styles.fullHeight}>
                        <div className={styles.paymentInfo + " " + "text-center"}>
                            <h3 className={styles.heading}>{t("SuccessKit.Manage")}<br />
                                {t("SuccessKit.Quick")}</h3>
                            <h3 className={styles.info}>{t("SuccessKit.Explore")} </h3>
                            <div className={styles.app + ' d-flex align-item-center gap-2 justify-content-center flex-wrap'}>
                                <a target='_blank' rel="noreferrer" href={"https://apps.apple.com/us/app/التعاونية-tawuniya/id1639353191"}><Ios /></a>
                                <a target='_blank' rel="noreferrer" href={"https://play.google.com/store/apps/details?id=com.dxp.TawuniyaInsurance"}><Android /></a>
                            </div>
                            <div className={styles.wavesWrapper}>
                                <img className={styles.screens} src={Screens} alt="ScreenImage" />
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                {showRow && <Col>
                    <h4 className={styles.downOurApp}>{t("SuccessKit.downOurApp")}</h4>
                    <div className={`d-flex gap-2 ` + styles.cards}>
                        <div className={styles.wrapper + " " + styles.flexBasis}>
                            <PolicyDown />
                            <div className={styles.policyDownload}>
                                <h6>{t("SuccessKit.Download")}</h6>
                                <p >{t("SuccessKit.DownPolicy")}</p>
                            </div>
                        </div>
                        <div className={styles.wrapper + " " + styles.flexBasis}
                        >
                            <PolicyInfo />
                            <div className={styles.policyDownload}>
                                <h6>{t("SuccessKit.Manage1")}</h6>
                                <p >{t("SuccessKit.ManagePolicy")}</p>
                            </div>
                        </div>
                        <div className={styles.wrapper + " " + styles.flexBasis}>
                            <PolicyDown />
                            <div className={styles.policyDownload}>
                                <h6>{t("SuccessKit.Download")}</h6>
                                <p >{t("SuccessKit.Membership")}</p>
                            </div>
                        </div>
                        <div className={styles.wrapper + " " + styles.flexBasis}>
                            <Services />
                            <div className={styles.policyDownload}>
                                <h6>{t("SuccessKit.view")}</h6>
                                <p >{t("SuccessKit.center")}</p>
                            </div>
                        </div>
                    </div>
                </Col>}
            </Row>
            <Row>
                <Col>
                    <div className={styles.wrapper}>
                        <div className='text-center'>
                            <h6 className={styles.heading}>{t("SuccessKit.Share")}</h6>
                            <p className={styles.info}>{t("SuccessKit.Help")}<br />{t("SuccessKit.socials")}</p>
                            <div className='d-flex justify-content-center flex-wrap'>
                                <a target="blank" href="https://twitter.com/tawuniya"><Twitter /></a>
                                <a target="blank" href="https://www.facebook.com/Tawuniya"><FaceBook /></a>
                                <a target="blank" href="https://www.youtube.com/tawuniya"><YouTube /></a>
                                <a target="blank" href="https://www.linkedin.com/company/tawuniya"><Linked /></a>
                                <a target="blank" href="https://wa.me/920009377"><WhatsApp /></a>
                                <a target="blank" href="https://www.instagram.com/tawuniya/"><Instagram /></a>
                            </div>
                            <p className={styles.info}>{t("SuccessKit.Copyright")}</p>
                        </div>
                    </div>
                </Col>
            </Row>
        </section>
    )
}

export default WelcomeKit